
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SuccessIcon',

  props: {
    mimeTypeSlag: String
  }
})
